<template>
  <div id="contact">
    <header-banner
      title="お見積り・デモ機貸出し・お問い合わせ"
      v-if="this.$isPC"
    />
    <header-banner title="お問い合わせ" v-else />
    <div class="contact-form-group">
      <div class="contact-by-phone" v-if="this.$isPC">
        <span class="notice">お急ぎの方はお電話からご連絡ください</span>
        <span class="phone-number">
          <a href="tel:076-294-4440">
            TEL.076-294-4440
          </a>
        </span>
      </div>
      <content-header
        title="インターネットからのお見積り・デモ機貸出し・お問い合わせフォーム"
        withBorder="true"
      />
      <div class="contact-form">
        <div class="notice">
          <span class="notice-left">
            必須事項を入力後、「確認画面へ」ボタンを押してください
          </span>
          <span class="notice-right">
            <span class="require-symbol">*</span>
            <span>必須項目</span>
          </span>
        </div>
        <table class="common-table contact-table">
          <tbody>
            <tr>
              <th>会社名</th>
              <td>
                <input v-model="contactForm.companyName" type="text" />
              </td>
            </tr>
            <tr>
              <th>会社名（フリガナ）</th>
              <td>
                <input v-model="contactForm.companyNameRuby" type="text" />
              </td>
            </tr>
            <tr>
              <th>
                お名前
                <span class="require-symbol">*</span>
              </th>
              <td>
                <input v-model="contactForm.name" type="text" />
              </td>
            </tr>
            <tr>
              <th>
                お名前（フリガナ）
                <span class="require-symbol">*</span>
              </th>
              <td>
                <input v-model="contactForm.nameRuby" type="text" />
              </td>
            </tr>
            <tr>
              <th>
                電話番号
                <span class="require-symbol">*</span>
              </th>
              <td>
                <input v-model="contactForm.phoneNumber" type="text" />
              </td>
            </tr>
            <tr>
              <th>
                FAX番号
              </th>
              <td>
                <input v-model="contactForm.faxNumber" type="text" />
              </td>
            </tr>
            <tr>
              <th>
                ご住所
                <span class="require-symbol">*</span>
              </th>
              <td>
                <tr>
                  <span style="display: inline-block; width: 80px;">
                    郵便番号
                    <span class="require-symbol">*</span>
                  </span>
                  <input v-model="contactForm.postalCode" type="text" />
                </tr>
                <tr>
                  <span style="display: inline-block; width: 80px;">
                    都道府県
                    <span class="require-symbol">*</span>
                  </span>
                  <input v-model="contactForm.prefecture" type="text" />
                </tr>
                <tr>
                  <span style="display: inline-block; width: 80px;">
                    市区町村
                    <span class="require-symbol">*</span>
                  </span>
                  <input v-model="contactForm.city" type="text" />
                </tr>
                <tr>
                  <span style="display: inline-block; width: 80px;">
                    町名番地
                    <span class="require-symbol">*</span>
                  </span>
                  <input v-model="contactForm.address" type="text" />
                </tr>
                <tr>
                  <span style="display: inline-block; width: 80px;">
                    建物名
                  </span>
                  <input v-model="contactForm.buildingName" type="text" />
                </tr>
              </td>
            </tr>
            <tr>
              <th>
                メールアドレス
                <span class="require-symbol">*</span>
              </th>
              <td>
                <input v-model="contactForm.email" type="text" />
              </td>
            </tr>
            <tr>
              <th>
                確認用メールアドレス
                <span class="require-symbol">*</span>
              </th>
              <td>
                <input v-model="contactForm.emailConfirm" type="text" />
              </td>
            </tr>
          </tbody>
        </table>

        <div class="notice-small">
          お見積りを依頼される方
        </div>
        <table class="common-table">
          <tbody>
            <tr>
              <th>商品名</th>
              <td>
                <label
                  v-for="(item, index) in productNames"
                  :key="index"
                  style="margin-right: 10px; cursor: pointer;"
                >
                  <input
                    v-model="contactForm.productCheckList[index]"
                    type="checkbox"
                    style="cursor: pointer;"
                  />
                  <span>
                    {{ productNames[index] }}
                  </span>
                  <br v-if="index % 3 == 2" />
                </label>
              </td>
            </tr>
            <tr>
              <th>
                お見積り内容<br />
                <span
                  style="font-weight: normal; display: inline-block; padding-top: 10px;"
                >
                  製品名（型式）、台数等、<br />
                  具体的にご入力ください
                </span>
              </th>
              <td>
                <textarea
                  v-model="contactForm.estimateContent"
                  style="width: 100%; height: 150px; border: 1px solid #ddd;"
                  placeholder="例：受信表示機(EC-100)ブラック1台、電池レス消去機(EC-400)1台、電池レス送信機 丸型 ホワイト(EC-311)10台、中継機(EC-500)1台"
                />
              </td>
            </tr>
          </tbody>
        </table>

        <div class="notice-small">
          デモ機貸出しを依頼される方
        </div>
        <table class="common-table">
          <tbody>
            <tr>
              <th>ご希望の商品名</th>
              <td>
                <label
                  v-for="(item, index) in productNames"
                  :key="index"
                  style="margin-right: 10px; cursor: pointer;"
                >
                  <input
                    v-model="contactForm.rentalCheckList[index]"
                    type="checkbox"
                    style="cursor: pointer;"
                  />
                  <span>
                    {{ productNames[index] }}
                  </span>
                  <br v-if="index % 3 == 2" />
                </label>
              </td>
            </tr>
            <tr>
              <th>
                デモ機内容<br />
                <span
                  style="font-weight: normal; display: inline-block; padding-top: 10px;"
                >
                  ご希望の送信機等、<br />
                  ご入力ください
                </span>
              </th>
              <td>
                <textarea
                  v-model="contactForm.rentalContent"
                  style="width: 100%; height: 150px; border: 1px solid #ddd;"
                  placeholder="例：受信表示機(EC-100)ブラック、電池レス消去機(EC-400)、電池レス送信機 丸型 ホワイト(EC-311)"
                />
              </td>
            </tr>
          </tbody>
        </table>

        <div class="notice-small">
          お問い合わせの方
        </div>
        <table class="common-table">
          <tbody>
            <tr>
              <th>
                お問い合わせ内容<br />
                <span
                  style="font-weight: normal; display: inline-block; padding-top: 10px;"
                >
                  ご質問やご要望等、<br />
                  ご入力ください
                </span>
              </th>
              <td>
                <textarea
                  v-model="contactForm.contactContent"
                  style="width: 100%; height: 150px; border: 1px solid #ddd;"
                />
              </td>
            </tr>
          </tbody>
        </table>

        <div class="form-button-group">
          <button v-on:click="sendMail">メール送信</button>
        </div>

        <image-modal v-if="showModal" @close="showModal = false">
          <div slot="body">
            <span v-html="modalMessage" />
          </div>
        </image-modal>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import ContentHeader from '@/components/modules/ContentHeader'
import ImageModal from '@/components/modules/products/features/ImageModal'
import HeaderBanner from '@/components/modules/HeaderBanner'

export default {
  components: {
    HeaderBanner,
    ContentHeader,
    ImageModal,
  },
  title: '無料お見積り・デモ機貸出し・お問い合わせ｜B-Call（ビーコール）',
  meta:
    'リモートリプライコール、リモートリプライコールPC、リプライコール、リプライコールPC、ビヨンドイーシー、エコチャイム、コココール、ファクトインコールのお見積り・デモ機貸出し・お問い合わせは、呼出しチャイム・呼出しシステムの専門店ビーコールにお任せください。',
  data: () => ({
    contactForm: {
      companyName: '',
      companyNameRuby: '',
      name: '',
      nameRuby: '',
      phoneNumber: '',
      faxNumber: '',
      postalCode: '',
      prefecture: '',
      city: '',
      address: '',
      buildingName: '',
      email: '',
      emailConfirm: '',
      productCheckList: [
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
      ],
      estimateContent: '',
      contactContent: '',
      rentalCheckList: [false, false, false, false, false, false, false, false],
      rentalContent: '',
      loading: false,
    },
    productNames: [
      'リモートリプライコール',
      'リモートリプライコールPC',
      'リプライコール',
      'リプライコールPC',
      'ビヨンドイーシー',
      'エコチャイム',
      'コココール',
      'ファクトインコール',
    ],
    showModal: false,
    modalMessage: '',
  }),
  methods: {
    sendMail: function() {
      var emptyItems = []
      var checkItems = [
        {
          key: '・お名前',
          value: this.contactForm.name,
        },
        {
          key: '・お名前（フリガナ）',
          value: this.contactForm.nameRuby,
        },
        {
          key: '・電話番号',
          value: this.contactForm.phoneNumber,
        },
        {
          key: '・郵便番号',
          value: this.contactForm.postalCode,
        },
        {
          key: '・都道府県',
          value: this.contactForm.prefecture,
        },
        {
          key: '・市区町村',
          value: this.contactForm.city,
        },
        {
          key: '・町名番地',
          value: this.contactForm.address,
        },
        {
          key: '・メールアドレス',
          value: this.contactForm.email,
        },
        {
          key: '・確認用メールアドレス',
          value: this.contactForm.emailConfirm,
        },
      ]

      checkItems.forEach(item => {
        if (!item.value) {
          emptyItems.push(item.key)
        }
      })

      if (emptyItems.length > 0) {
        this.showModal = true
        this.modalMessage =
          `以下の項目が未入力のようです。<br /><br />` +
          emptyItems.join('<br />')
        return
      }

      if (this.contactForm.email !== this.contactForm.emailConfirm) {
        this.showModal = true
        this.modalMessage =
          `ご入力いただいたメールアドレスと確認用メールアドレスが一致していません。<br /><br />
        メールアドレス : ` +
          this.contactForm.email +
          `<br />確認用メールアドレス : ` +
          this.contactForm.emailConfirm
        return
      }

      this.showModal = true
      this.modalMessage = `メール送信中`

      axios
        .post(
          'https://us-central1-test-f350d.cloudfunctions.net/sendMail',
          // 'http://localhost:5001/bcall-mail-4396c/us-central1/sendMail',
          {
            data: {
              companyName: this.contactForm.companyName,
              companyNameRuby: this.contactForm.companyNameRuby,
              name: this.contactForm.name,
              nameRuby: this.contactForm.nameRuby,
              phoneNumber: this.contactForm.phoneNumber,
              faxNumber: this.contactForm.faxNumber,
              postalCode: this.contactForm.postalCode,
              prefecture: this.contactForm.prefecture,
              city: this.contactForm.city,
              address: this.contactForm.address,
              buildingName: this.contactForm.buildingName,
              email: this.contactForm.email,
              emailConfirm: this.contactForm.emailConfirm,
              productCheckList: this.contactForm.productCheckList,
              estimateContent: this.contactForm.estimateContent,
              contactContent: this.contactForm.contactContent,
              rentalCheckList: this.contactForm.rentalCheckList,
              rentalContent: this.contactForm.rentalContent,
            },
          }
        )
        .then(() => {
          this.showModal = true
          this.modalMessage = `<div style="text-align: center; font-weight: bold; color: rgb(8, 76, 132); margin-bottom: 10px; font-size: 20px;">メールの送信に成功しました。</div>
            この度は「B-Call」にお問い合わせいただき、誠にありがとうございます。<br />
            お問い合わせいただいた内容につきましては確認の上、弊社担当よりご連絡させていただきます。<br />
            お問い合わせ内容により調査のためのお時間をいただく場合もございますのでご了承ください。<br />
            <br />
            尚、ご入力いただいたメールアドレス宛に、確認メールを送信しております。<br />
            メールが届かなかった場合は
            <span style="font-weight: bold">info@b-call.jp</span>
            の受信許可をしていただくか、<br />
            ご入力いただいたメールアドレスに誤りがないか、ご確認をお願いいたします。`
        })
        .catch(err => {
          console.log(err)
          this.showModal = true
          this.modalMessage = `<div style="text-align: center; font-weight: bold; color: red; margin-bottom: 10px; font-size: 20px;">メールの送信に失敗しました。</div>
          お手数ですが、時間をおいて再度お試しいただくか、以下のお問い合わせ窓口までお問い合わせをお願いいたします。<br />
          <br />
          <p style="font-size: 18px; font-weight: bold; margin: 3px 0;">
            株式会社ビーアッサ
          </p>
          本&emsp;社：〒922-0101 石川県加賀市山中温泉中田町ハ-101<br />
          営業所：〒921-8811 石川県野々市市高橋町10-18<br />
          TEL : 076-294-4440 &emsp;FAX : 076-294-4432 &emsp;E-MAIL : info@b-call.jp`
        })
    },
  },
}
</script>

<style scoped>
.contact-form-group {
  display: flex;
  flex-direction: column;

  width: 90%;
  max-width: 1100px;
}

.contact-form-group .contact-by-phone {
  line-height: 46px;

  display: flex;
  justify-content: center;

  margin-bottom: 20px;

  text-align: center;
  vertical-align: middle;
}

.contact-form-group .contact-by-phone span {
  font-weight: bold;

  display: inline-block;

  width: 50%;
  padding: 10px 0;

  border: 1px solid rgb(26, 159, 227);
}

.contact-form-group .contact-by-phone .notice {
  font-size: 22px;

  color: white;
  border-radius: 8px 0 0 8px;
  background-color: rgb(26, 159, 227);
}

.contact-form-group .contact-by-phone .phone-number {
  font-size: 34px;

  color: rgb(8, 76, 132);
  border-radius: 0 8px 8px 0;
  background-color: white;
}

.contact-form-group .contact-by-phone .phone-number a {
  text-decoration: none;

  color: rgb(8, 76, 132);
}

.contact-form .notice {
  font-size: 12px;

  display: flex;
  justify-content: space-between;

  margin-top: 15px;
  padding: 5px;
}

.require-symbol {
  font-weight: bold;

  vertical-align: sub;

  color: red;
}

.contact-table input {
  width: 90%;
  max-width: 300px;

  border-width: 1px;
  border-style: double;
  border-color: #ddd;
}

.form-button-group {
  display: flex;
  justify-content: center;

  margin: 30px 0 20px 0;
}

.form-button-group button {
  font-weight: bold;

  display: inline-block;

  width: 80px;
  padding: 5px 0;

  border: 1px solid #ddd;
  background-color: rgb(218, 241, 255);
}

.form-button-group button + button {
  margin-left: 10px;
}

.common-table th {
  font-size: 12px;
  font-weight: bold;

  padding: 10px 20px;

  text-align: left;
  vertical-align: top;
}

.common-table td {
  font-size: 12px;
}

.contact-form .notice-small {
  font-size: 14px;
  font-weight: bold;

  margin: 25px 0 10px 0;

  color: rgb(8, 76, 132);
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Contact.vue